import {createSlice} from "@reduxjs/toolkit";
import React from "react";
const initialState = {
    isNewArticle:false
};
const FormReducer = createSlice({
    name: "FormReducer",
    initialState: initialState,
    reducers: {
       openCreateNewArticle: (state) => {
            return {
                ...state,
                isCreateNewArticle: true,
            };
        },closeCreateNewArticle: (state) => {
            return {
                ...state,
                isCreateNewArticle: false,
            };
        }
    }
});

export default FormReducer;
